import {
  ClassificationColors,
  ClassificationProps,
  RiskLevel
} from './Classification.types';

const classificationColors: Record<RiskLevel, ClassificationColors> = {
  prohibited: {
    textColor: '#BE123C',
    bgColor: '#FFE4E6'
  },
  high: {
    textColor: '#C2410C',
    bgColor: '#FFEDD5'
  },
  limited: {
    textColor: '#B45309',
    bgColor: '#FEF3C7'
  },
  minimal: {
    textColor: '#027A69',
    bgColor: '#D0FBEB'
  },
  excluded: {
    textColor: '#4E4E56',
    bgColor: '#EEEEF0'
  },
  'out-of-scope': {
    textColor: '#4E4E56',
    bgColor: '#EEEEF0'
  }
};

export function Classification({ risk, text }: ClassificationProps) {
  const colors = classificationColors[risk] || {
    textColor: '#374151', // tamno siva (skoro crna)
    bgColor: '#F3F4F6' // svetlo siva pozadina
  };
  return (
    <div className="flex flex-col gap-2 items-end">
      <span className="text-xs leading-5 text-gray-550 font-medium uppercase">
        classification:
      </span>
      <div
        className="w-min px-3 py-0.5 rounded-xl text-xs leading-4 font-medium text-nowrap"
        style={{
          color: colors.textColor,
          backgroundColor: colors.bgColor
        }}
      >
        {text}
      </div>
    </div>
  );
}
